import React, { useState, useEffect } from 'react';
import { Grid, TextField, FormControl, Typography, Button, MenuItem, Select, InputLabel } from '@mui/material';
import { fetchStates, fetchSubDistrict } from 'API/AgentOnboarding/api';

const Address = (props) => {
  const UserList = props.UserList;
  const [State, setState] = useState('');
  const [subDistrict, setSubDistrict] = useState(null);

  // const handleNext = () => {
  //   props.handleStep({
  //     home_address: props.postData.home_address&&props.postData.home_address,
  //     home_city_village: props.postData.home_city_village&&props.postData.home_city_village,
  //     home_district: props.postData.home_district&&props.postData.home_district,
  //     home_pincode: props.postData.home_pincode&&props.postData.home_pincode,
  //     home_region: props.postData.home_region&&props.postData.home_region,
  //     home_state: props.postData.home_state&&props.postData.home_state,
  //     home_sub_district: props.postData.home_sub_district&&props.postData.home_sub_district,
  //     retail_address: props.postData.retail_address&&props.postData.retail_address,
  //     retail_city_village: props.postData.retail_city_village&&props.postData.retail_city_village,
  //     retail_district: props.postData.retail_district&&props.postData.retail_district,
  //     retail_pincode: props.postData.retail_pincode&&props.postData.retail_pincode,
  //     retail_state: props.postData.retail_state&&props.postData.retail_state,
  //     retail_sub_district: props.postData.retail_sub_district&&props.postData.retail_sub_district,
  //   }),
  //     props.handleNext();
  // };
  const handleInput = (e) => {
    const value = e.target.value;
    e.target.value = value.replace(/[^A-Za-z0-9\s]/g, '');
  };
  const handleNext = () => {
    // Get only the keys that have a defined value in postData
    const updatedData = Object.keys(props.postData).reduce((acc, key) => {
      if (props.postData[key] !== undefined && props.postData[key] !== null) {
        acc[key] = props.postData[key]; // Only store non-null and non-undefined values
      }
      return acc;
    }, {});

    props.handleStep(updatedData);
    props.handleNext();
  };
  const handleNumberInput = (e) => {
    const value = e.target.value;
    e.target.value = value.replace(/[^0-9]/g, '');
  };
  useEffect(() => {
    fetchStates(setState);
    // fetchSubDistrict(
    //   props.postData.home_district || UserList.home_district || UserList.retail_district || props.postData.retail_district,
    //   setSubDistrict
    // );
  }, []);
  useEffect(() => {
    const district =
      props.postData.home_district ||
      // UserList.home_district ||
      //  UserList.retail_district ||
      props.postData.retail_district;
    // console.log("district",district,"UserList.retail_district",UserList.retail_district);

    if (district) {
      fetchSubDistrict(district, setSubDistrict);
    }
  }, [
    props.postData.home_district,
    // UserList.home_district,
    // UserList.retail_district,
    props.postData.retail_district
  ]);

  return (
    <>
      <Typography variant="h4" sx={{ mb: 2 }}>
        Home Address
      </Typography>

      <Grid container spacing={2} fullwidth>
        <Grid item xl={6} lg={6} md={6} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <TextField
              label="Home Address"
              name="home_address"
              variant="standard"
              onChange={(e) => props.handlePostChange(e)}
              value={props.postData.home_address ?? UserList.home_address ?? ''}
            />
          </FormControl>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={6} xs={12}>
          <FormControl fullWidth>
            <TextField
              label="Landmark"
              onInput={handleInput}
              name="home_landmark"
              variant="standard"
              onChange={(e) => props.handlePostChange(e)}
              value={props.postData.home_landmark ?? UserList.home_landmark ?? ''}
            />
          </FormControl>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <TextField
              label="Pincode"
              name="home_pincode"
              variant="standard"
              onInput={handleNumberInput}
              onChange={(e) => props.handlePostChange(e)}
              value={props.postData.home_pincode ?? UserList.home_pincode ?? ''}
            />
          </FormControl>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <InputLabel htmlFor="outlined-adornment-lname-register">Region</InputLabel>
            <Select
              label="Region"
              name="home_region"
              variant="standard"
              onChange={(e) => props.handlePostChange(e)}
              value={props.postData.home_region || UserList.home_region}
            >
              <MenuItem value="" disabled>
                Select
              </MenuItem>
              <MenuItem value={UserList.home_region} sx={{ display: 'none' }}>
                {UserList.home_region}
              </MenuItem>
              {/* <MenuItem value="North">{}</MenuItem> */}
              <MenuItem value="North">North</MenuItem>
              <MenuItem value="South">South</MenuItem>
              <MenuItem value="East">East</MenuItem>
              <MenuItem value="West">West</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">State</InputLabel>
            <Select
              label="State"
              name="home_state"
              variant="standard"
              onChange={(e) => props.handlePostChange(e)}
              value={props.postData.home_state || UserList.home_state}
            >
              <MenuItem value={'select'} disabled>
                Select
              </MenuItem>
              {UserList.home_state && (
                <MenuItem value={UserList.home_state} sx={{ display: 'none' }}>
                  {UserList.home_state}
                </MenuItem>
              )}
              {State &&
                Object.entries(State).map(([key]) => (
                  <MenuItem value={key} key={key}>
                    {key}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">District</InputLabel>

            <Select
              label="District"
              name="home_district"
              variant="standard"
              // onChange={(e) => props.handlePostChange(e)}
              onChange={(e) => {
                props.handlePostChange(e);
                setSubDistrict(null);
                fetchSubDistrict(e.target.value, setSubDistrict);
              }}
              value={props.postData.home_district || UserList.home_district}
              // value={props.postData.home_district || ''}
            >
              <MenuItem value={'select'} disabled>
                Select
              </MenuItem>
              {UserList.home_district && (
                <MenuItem value={UserList.home_district} sx={{ display: 'none' }}>
                  {UserList.home_district}
                </MenuItem>
              )}
              {State &&
                (props.postData.home_state || UserList.home_state) &&
                State[props.postData.home_state || UserList.home_state]?.map((district, index) => (
                  <MenuItem value={district} key={index}>
                    {district}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <InputLabel htmlFor="outlined-adornment-lname-register">Sub district</InputLabel>

            <Select
              label="Sub District"
              name="home_sub_district"
              variant="standard"
              onChange={(e) => props.handlePostChange(e)}
              value={props.postData.home_sub_district || UserList.home_sub_district}
            >
              <MenuItem value={'select'} disabled>
                Select
              </MenuItem>
              {UserList.home_sub_district && (
                <MenuItem value={UserList.home_sub_district} sx={{ display: 'none' }}>
                  {UserList.home_sub_district}
                </MenuItem>
              )}
              {subDistrict
                ? Object.entries(subDistrict).map(([key]) => (
                    <MenuItem key={key} value={key}>
                      {key}
                    </MenuItem>
                  ))
                : null}
              {/* {subDistrict && props.postData.home_district && subDistrict[props.postData.home_district]
                ? subDistrict[props.postData.home_district].map((item, index) => (
                    <MenuItem key={index} value={item}>
                      {item}
                    </MenuItem>
                  ))
                : null} */}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <InputLabel htmlFor="outlined-adornment-lname-register">City / Village</InputLabel>

            <Select
              label="City/ Village"
              name="home_city_village"
              variant="standard"
              onChange={(e) => props.handlePostChange(e)}
              value={props.postData.home_city_village || UserList.home_city_village}
            >
              <MenuItem value={'select'} disabled>
                Select
              </MenuItem>
              {UserList.home_city_village && (
                <MenuItem value={UserList.home_city_village} sx={{ display: 'none' }}>
                  {UserList.home_city_village}
                </MenuItem>
              )}
              {subDistrict &&
              (props.postData.home_sub_district || UserList.home_sub_district) &&
              subDistrict[props.postData.home_sub_district || UserList.home_sub_district]
                ? subDistrict[props.postData.home_sub_district || UserList.home_sub_district].map((item, index) => (
                    <MenuItem key={index} value={item}>
                      {item}
                    </MenuItem>
                  ))
                : null}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Typography variant="h4" sx={{ mt: 2, mb: 2 }}>
        Retail Address
      </Typography>
      <Grid container spacing={2} fullwidth>
        <Grid item xl={6} lg={6} md={6} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <TextField
              label="Retail Address"
              name="retail_address"
              variant="standard"
              onChange={(e) => props.handlePostChange(e)}
              value={props.postData.retail_address ?? UserList.retail_address ?? ''}
            />
          </FormControl>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <TextField
              label="Pincode"
              name="retail_pincode"
              variant="standard"
              onInput={handleNumberInput}
              onChange={(e) => props.handlePostChange(e)}
              value={props.postData.retail_pincode ?? UserList.retail_pincode ?? ''}
            />
          </FormControl>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">State</InputLabel>
            <Select
              label="State"
              name="retail_state"
              variant="standard"
              onChange={(e) => props.handlePostChange(e)}
              value={props.postData.retail_state || UserList.retail_state}
            >
              <MenuItem value={'select'} disabled>
                Select
              </MenuItem>
              <MenuItem value={UserList.retail_state} sx={{ display: 'none' }}>
                {UserList.retail_state}
              </MenuItem>
              {State &&
                Object.entries(State).map(([key]) => (
                  <MenuItem value={key} key={key}>
                    {key}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">District</InputLabel>

            <Select
              label="District"
              name="retail_district"
              variant="standard"
              // onChange={(e) => props.handlePostChange(e)}
              onChange={(e) => {
                props.handlePostChange(e);
                // setSubDistrict(null);
                fetchSubDistrict(e.target.value, setSubDistrict);
              }}
              value={props.postData.retail_district || UserList.retail_district}
              // value={props.postData.retail_district || ''}
            >
              <MenuItem value={'select'} disabled>
                Select
              </MenuItem>
              {UserList.retail_district && (
                <MenuItem value={UserList.retail_district} sx={{ display: 'none' }}>
                  {UserList.retail_district}
                </MenuItem>
              )}
              {State &&
                (props.postData.retail_state || UserList.retail_state) &&
                State[props.postData.retail_state || UserList.retail_state]?.map((district, index) => (
                  <MenuItem value={district} key={index}>
                    {district}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <InputLabel htmlFor="outlined-adornment-lname-register">Sub district</InputLabel>

            <Select
              label="Sub District"
              name="retail_sub_district"
              variant="standard"
              onChange={(e) => props.handlePostChange(e)}
              value={props.postData.retail_sub_district || UserList.retail_sub_district}
            >
              <MenuItem value={'select'} disabled>
                Select
              </MenuItem>
              {UserList.retail_sub_district && (
                <MenuItem value={UserList.retail_sub_district} sx={{ display: 'none' }}>
                  {UserList.retail_sub_district}
                </MenuItem>
              )}
              {subDistrict
                ? Object.entries(subDistrict).map(([key]) => (
                    <MenuItem key={key} value={key}>
                      {key}
                    </MenuItem>
                  ))
                : null}
              {/* {subDistrict &&
              (props.postData.retail_district || UserList.retail_district) &&
              subDistrict[props.postData.retail_district || UserList.retail_district]
                ? subDistrict[props.postData.retail_district || UserList.retail_district].map((item, index) => (
                    <MenuItem key={index} value={item}>
                      {item}
                    </MenuItem>
                  ))
                : null} */}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <InputLabel htmlFor="outlined-adornment-lname-register">City / Village</InputLabel>

            <Select
              label="City / Village"
              name="retail_city_village"
              variant="standard"
              onChange={(e) => props.handlePostChange(e)}
              value={props.postData.retail_city_village || UserList.retail_city_village}
            >
              <MenuItem value={'select'} disabled>
                Select
              </MenuItem>
              {UserList.retail_city_village && (
                <MenuItem value={UserList.retail_city_village} sx={{ display: 'none' }}>
                  {UserList.retail_city_village}
                </MenuItem>
              )}
              {subDistrict && props.postData.retail_sub_district && subDistrict[props.postData.retail_sub_district]
                ? subDistrict[props.postData.retail_sub_district].map((item, index) => (
                    <MenuItem key={index} value={item}>
                      {item}
                    </MenuItem>
                  ))
                : null}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <TextField
              label="Latitude"
              variant="standard"
              onChange={(e) => props.handlePostChange(e)}
              value={props.postData.latitude || UserList.latitude}
              inputProps={{
                readOnly: true
              }}
            />
          </FormControl>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <TextField
              label="Longitude"
              variant="standard"
              onChange={(e) => props.handlePostChange(e)}
              value={props.postData.longitude || UserList.longitude}
              inputProps={{
                readOnly: true
              }}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container mt={2} display={'flex'} justifyContent={'center'}>
        <Button
          color="secondary"
          variant="outlined"
          sx={{
            mr: 2,
            width: '25%',
            borderColor: '#688B2A',
            color: '#688B2A',
            borderRadius: '6px',
            '&:hover': {
              borderColor: '#688B2A'
            }
          }}
          onClick={props?.handleBank}
        >
          back
        </Button>
        <Button
          color="secondary"
          variant="contained"
          sx={{
            width: '25%',
            backgroundColor: '#688B2A',
            color: '#FFFFFF',
            borderRadius: '6px',
            '&:hover': {
              backgroundColor: '#688B2A'
            }
          }}
          onClick={handleNext}
        >
          update
        </Button>
      </Grid>
    </>
  );
};

export default Address;
